import { render, staticRenderFns } from "./BannedDomains.vue?vue&type=template&id=ea185056&"
import script from "./BannedDomains.vue?vue&type=script&lang=js&"
export * from "./BannedDomains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports